/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CoinsVolumeLeadersResponseDataInner } from './CoinsVolumeLeadersResponseDataInner';
import {
    CoinsVolumeLeadersResponseDataInnerFromJSON,
    CoinsVolumeLeadersResponseDataInnerFromJSONTyped,
    CoinsVolumeLeadersResponseDataInnerToJSON,
} from './CoinsVolumeLeadersResponseDataInner';

/**
 * 
 * @export
 * @interface CoinsVolumeLeadersResponse
 */
export interface CoinsVolumeLeadersResponse {
    /**
     * 
     * @type {Array<CoinsVolumeLeadersResponseDataInner>}
     * @memberof CoinsVolumeLeadersResponse
     */
    data: Array<CoinsVolumeLeadersResponseDataInner>;
}

/**
 * Check if a given object implements the CoinsVolumeLeadersResponse interface.
 */
export function instanceOfCoinsVolumeLeadersResponse(value: object): value is CoinsVolumeLeadersResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CoinsVolumeLeadersResponseFromJSON(json: any): CoinsVolumeLeadersResponse {
    return CoinsVolumeLeadersResponseFromJSONTyped(json, false);
}

export function CoinsVolumeLeadersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinsVolumeLeadersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CoinsVolumeLeadersResponseDataInnerFromJSON)),
    };
}

export function CoinsVolumeLeadersResponseToJSON(value?: CoinsVolumeLeadersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(CoinsVolumeLeadersResponseDataInnerToJSON)),
    };
}

